// Deployment Configuration
// This file provides deployment-specific configurations

export interface DeploymentConfig {
  name: string;
  apiBaseUrl: string;
  wsUrl: string;
  description: string;
}

export const deploymentConfigs: Record<string, DeploymentConfig> = {
  local: {
    name: 'Local Development',
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
    wsUrl: import.meta.env.VITE_WS_URL || '',
    description: 'Local development environment'
  },
  production: {
    name: 'Production',
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
    wsUrl: import.meta.env.VITE_WS_URL || '',
    description: 'Production deployment'
  },
  azure: {
    name: 'Azure',
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
    wsUrl: import.meta.env.VITE_WS_URL || '',
    description: 'Azure deployment'
  },
  docker: {
    name: 'Docker',
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
    wsUrl: import.meta.env.VITE_WS_URL || '',
    description: 'Docker container deployment'
  }
};

// Get current deployment configuration (Vite injects only vars from `.env` / `.env.local`)
export const getCurrentDeploymentConfig = (): DeploymentConfig => {
  const envApiUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() ?? '';
  const envWsUrl = (import.meta.env.VITE_WS_URL as string | undefined)?.trim() ?? '';

  if (envApiUrl && envWsUrl) {
    return {
      name: 'Environment Variables',
      apiBaseUrl: envApiUrl,
      wsUrl: envWsUrl,
      description: 'From VITE_API_BASE_URL and VITE_WS_URL in .env / .env.local',
    };
  }

  console.warn(
    'Set VITE_API_BASE_URL and VITE_WS_URL in .env or .env.local. API and WebSocket URLs are not derived from the page hostname.',
  );
  return {
    name: 'Unset',
    apiBaseUrl: '',
    wsUrl: '',
    description: 'Missing VITE_API_BASE_URL or VITE_WS_URL',
  };
};

// Export the current configuration
export const currentDeployment = getCurrentDeploymentConfig();
